import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioEvents, ProStudioContext } from '../prostudio.xstate.types';
import { fetchVersionFileContent } from '../../utils';

export const getFileData = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  type: string;
  fileData: string;
  fileName: string;
  cb?: (data: string) => void;
} | void> => {
  if (event.type !== 'downloadScript' && event.type !== 'editScript') {
    return;
  }

  const { botName, customerId, draftVersion, project } = ctx;

  const projectId = project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  if (!botName) {
    throwErrorWithId('Bot Name is required');
  }

  if (!customerId) {
    throwErrorWithId('Customer ID is required');
  }

  const botId = `${customerId}.${botName}`;

  if (!draftVersion) {
    throwErrorWithId('Draft version is required (getFileData)');
  }

  const versionId = `${botId}.${draftVersion}`;

  // See `fetchVersionFileContent` for the dual-channel extraction contract.
  // Script download/edit always targets the draft version, which currently
  // returns content via the legacy error channel, but the helper handles
  // both channels so this caller stays correct if the backend ever switches.
  const fileData = await fetchVersionFileContent({
    projectId,
    versionId,
    filePath: event.path,
  });

  return {
    type: event.type,
    fileData,
    fileName: event.name,
    cb: event.cb,
  };
};
